import { useMemo } from 'react';
import type { Academy } from '@court-sync/shared';
import { useCurrentClub } from '@/hooks/useCurrentClub';
import { resolveFacilityClub } from '@/utils/facilityClub';

/**
 * Club that owns courts/locations for the current academy operator context.
 * Includes internal shell clubs for academy-only Starter organizations.
 */
export function useFacilityClub(academy: Academy | null | undefined) {
  const { currentClub, userClubs, isLoading } = useCurrentClub();

  const facilityClub = useMemo(
    () => resolveFacilityClub(academy, currentClub, userClubs),
    [academy, currentClub, userClubs]
  );

  return { facilityClub, isLoading };
}
